"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vendor = exports.PLUGIN_NAME = exports.BuildEnv = void 0;
var BuildEnv;
(function (BuildEnv) {
    BuildEnv["DEV"] = "dev";
    BuildEnv["STG"] = "staging";
    BuildEnv["PRODUCTION"] = "production";
})(BuildEnv = exports.BuildEnv || (exports.BuildEnv = {}));
exports.PLUGIN_NAME = 'MessageMediaTransformMultiThemesPlugin';
var Vendor;
(function (Vendor) {
    Vendor["MESSAGEMEDIA"] = "mm";
    Vendor["MULTITXT"] = "vodanz";
    Vendor["DIRECTSMS"] = "directSMS";
    Vendor["STREETDATA"] = "streetdata";
    Vendor["WHOLESALESMS"] = "wholesale";
    Vendor["TWO_DEGREES"] = "2degrees";
    Vendor["SMSB"] = "smsb";
    Vendor["MESSAGENET"] = "messagenet";
    Vendor["MOBIPOST"] = "mobipost";
    Vendor["SMSCENTRAL"] = "smscentral";
    Vendor["BULLETIN"] = "bulletin";
    Vendor["ETXT"] = "etxt";
    Vendor["TPGTELECOM"] = "tpgtelecom";
    Vendor["SIMPLE_TEXTING"] = "simpletexting";
    Vendor["MESSAGE_STUDIO"] = "messagestudio";
    Vendor["SINCH_EU"] = "sincheu";
    Vendor["NOTIFY_NOW"] = "notify-now";
})(Vendor = exports.Vendor || (exports.Vendor = {}));
//# sourceMappingURL=types.js.map